import React from "react";
import heroimg from "../../assets/img/Hero.jpg";
import herovideo from "../../assets/video/orbit.mp4";
import ai from "../../assets/img/carousel/AII.jpg";
import carousel3 from "../../assets/img/carousel/carousel3.jpg";
import carousel4 from "../../assets/img/carousel/carousel45.jpg";
import carousel5 from "../../assets/img/carousel/carousel5.jpg";
import carousel7 from "../../assets/img/carousel/carousel7.jpg";
import "./Hero.css";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const Hero = () => {
  const heroArrray = [
    {
      title: "Data Collection & Integration",
      description:
        "Before any analysis can take place, data needs to be collected, processed, and combined from different sources.",
      video: herovideo,
      image: "",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: carousel3,
      position:"center center",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: heroimg,
      position:"center center",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: carousel4,
      position:"center center",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: carousel5,
      position:"center center",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: carousel7,
      position:"center center",
    },
    {
      title: "OrbiNexum <br />The BigData Analytics Contents",
      description:
        "  Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.<br /><br />These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.",
      video: "",
      image: ai,
      position:"center center",
    },
  ];
  return (
    <div className="hero-container">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        style={{ height: "100vh" }}
      >
        {/* First Slide - Video */}
        {heroArrray.map((item, index) =>
          item.video !== "" ? (
            <SwiperSlide key={index}>
              <div
                className="video-slide"
                style={{ height: "100vh", position: "relative" }}
              >
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                >
                  <source src={item.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <motion.div
                  className="hero-content p-5 mt-3 position-relative d-flex flex-column justify-content-center align-items-start"
                  style={{ zIndex: 1, height: "100vh" }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 2 }}
                >
                  <h1
                    style={{
                      fontSize: "4rem",
                      width: "50%",
                      textShadow: "rgb(5 16 33) 0px 0px 10px",
                      color: "#fff",
                    }}
                    dangerouslySetInnerHTML={{__html: item.title}}
                  >
                  </h1>
                  <h5
                    style={{
                      width: "50%",
                      textShadow: "3px 2px 6px black",
                      fontSize: "1.5rem",
                      color: "#ffb81c",
                    }}
                    dangerouslySetInnerHTML={{__html: item.description}}
                  >
                  </h5>
                </motion.div>
              </div>
            </SwiperSlide>
          ) : (
            <SwiperSlide key={index}>
              <div
                className="d-flex flex-row justify-content-center align-items-center"
                style={{
                  height: "100vh",
                  backgroundImage: `url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: item.position,
                  backgroundRepeat: "no-repeat",
                }}
              >
                <motion.div
                  className="hero-content w-100 p-5"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 2 }}
                >
                  <h1
                    style={{
                      fontSize: "4rem",
                      width: "50%",
                      textShadow: "rgb(5 16 33) 0px 0px 10px",
                      color: "#fff",
                    }}
                    dangerouslySetInnerHTML={{__html: item.title}}
                  >
                  </h1>
                  <h5
                    style={{
                      width: "50%",
                      color: "#ffb81c",
                      textShadow: "3px 2px 6px black",
                      fontSize: "1.5rem",
                    }}
                    dangerouslySetInnerHTML={{__html: item.description}}
                  >
                  </h5>
                </motion.div>
              </div>
            </SwiperSlide>
          )
        )}

        {/* Third Slide - AI Background Image */}
        {/* <SwiperSlide>
          <div className='d-flex flex-row justify-content-center align-items-center' 
               style={{ height: '100vh', backgroundImage: `url(${ai})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <motion.div className='hero-content w-100 p-5'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 2 }}
            >
              <h1 style={{ fontSize: '4rem', width: '50%', textShadow: 'rgb(5 16 33) 0px 0px 10px' }}>
                OrbiNexum
                <br />
                The BigData Analytics Contents
              </h1>
              <h5 style={{ width: '50%', color: '#ffb81c', textShadow: '3px 2px 6px black' }}>
                Every day, the world generates approximately 402.74 million terabytes of data, encompassing everything from social media interactions to financial transactions.
                <br /><br />
                These specialized firms transform raw data into actionable insights, enabling businesses to make informed decisions.
              </h5>
            </motion.div>
          </div>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default Hero;
